const API_BASE = import.meta.env.VITE_API_URL ?? "";

/**
 * Full-page navigation to start the Shopify "Sign in with Shopify" flow.
 * The backend builds the PKCE authorize URL and redirects to Shopify; after
 * login it redirects the browser back to `/kit?status=…` (or `/r/{token}`).
 */
export function startShopifyLogin(): void {
  window.location.href = `${API_BASE}/api/auth/shopify/login`;
}
